module.exports = __webpack_public_path__ + "static/tel-1c4a369f698553feeefd4dd2d649dc2d.png";